<div class="ai-chat-chart">
  <div class="ai-chat-chart-header">
    <h4 *ngIf="title" class="ai-chat-chart-title">{{ title }}</h4>
    <button
      type="button"
      class="ai-chat-chart-download"
      (click)="downloadChart()"
      title="Descargar gráfico como PNG"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="ai-chat-chart-download-icon">
        <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/>
      </svg>
      <span>Descargar PNG</span>
    </button>
  </div>

  <div class="ai-chat-chart-canvas-wrapper">
    <canvas
      baseChart
      [data]="chartConfig.data"
      [type]="chartConfig.type"
      [options]="chartConfig.options"
    ></canvas>
  </div>
</div>
